import Api from './Api';

const all = (payload) => {
    const path = '/invoices';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const search = (payload) => {
    const path = '/invoice/search';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const invoiceReportBySite = (payload) => {
    const path = '/invoice/invoice-report-by-site';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const invoiceSummaryReportBySite = (payload) => {
    const path = '/invoice/invoice-summary-report-by-site';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const siteSummaryReports = (payload) => {
    const path = '/invoice/site-summary-reports';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const store = (payload) => {
    return Api.postRequest({
        endpoint: '/invoice/store',
        data: payload
    });
};

const get = (payload) => {
    return Api.getRequest({
        endpoint: `/invoice/get-by-invoice-id/${payload.id}`,
    });
};

const updateManualPayment = (payload)=> {
    return Api.postRequest({
        endpoint: '/invoice/update-manual-payment',
        method: 'PUT',
        data: payload
    });
}

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/invoice/update',
        method: 'PUT',
        data: payload
    });
};

const destroy = (payload) => {
    return Api.deleteRequest({
        endpoint: `/invoice/destroy/${payload.id}`,
    });
};

const restore = (payload) => {
    return Api.postRequest({
        endpoint: '/invoice/restore',
        method: 'PUT',
        data: payload
    });
};

const restoreInvoice = (payload) => {
    return Api.postRequest({
        endpoint: '/invoice/restore-invoice',
        method: 'PUT',
        data: payload
    });
};

const softDelete = (payload) => {
    return Api.deleteRequest({
        endpoint: `/invoice/soft-delete/${payload.id}`,
    });
};

const resendPaymentMail = (payload) => {
    return Api.postRequest({
        endpoint: '/invoice/resend-payment-mail',
        data: payload
    });
};

const reminderMail = (payload) => {
    return Api.postRequest({
        endpoint: `/invoice/reminder-mail`,
        data: payload
    });
};

const afterReminderMail = (payload) => {
    return Api.postRequest({
        endpoint: `/invoice/after-reminder-mail`,
        data: payload
    });
};

const republish = (payload) => {
    return Api.postRequest({
        endpoint: '/invoice/republish',
        method: 'PUT',
        data: payload
    });
};

const replacement = (payload) => {
    return Api.postRequest({
        endpoint: '/invoice/replaced-live-link',
        method: 'PUT',
        data: payload
    });
};

const invoiceDetails = (payload) => {
    return Api.getRequest({
        endpoint: `/invoice/get-by-invoice-details/${payload.id}`,
    });
};


const getAllUnreadMessages = (payload) => {
    const path = '/get-all-unread-messages';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const invoiceMarkAsRead = (payload) => {
    return Api.postRequest({
        endpoint: '/invoice/mark-as-read',
        method: 'PUT',
        data: payload
    });
};

const refund = (payload) => {
    return Api.postRequest({
        endpoint: `/invoice/refund`,
        method: 'PUT',
        data: payload
    });
}
const mergedRefund = (payload) => {
    return Api.postRequest({
        endpoint: `/merged-invoice/refund`,
        method: 'PUT',
        data: payload
    });
}

const republishedEmail = (payload) => {
    return Api.postRequest({
        endpoint: `/invoice/email/republished`,
        data: payload
    });
}

export default {
    all,
    search,
    get,
    store,
    updateManualPayment,
    update,
    destroy,
    restore,
    restoreInvoice,
    softDelete,
    resendPaymentMail,
    reminderMail,
    afterReminderMail,
    invoiceReportBySite,
    invoiceSummaryReportBySite,
    republish,
    replacement,
    invoiceDetails,
    getAllUnreadMessages,
    invoiceMarkAsRead,
    siteSummaryReports,
    refund,
    mergedRefund,
    republishedEmail
};
